/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @author Jiri Moc <jiri.moc@outlook.cz>
 * @license See LICENSE file distributed with this source code.
 */

import { FormRepository } from "../shared/FormRepository";
import { form_zadavaciProtokol } from "./zadavaciProtokol";
import { form_gdpr } from "./gdpr";
import { form_cenovaNabidkaKuchynSestava } from "./cenovaNabidkaKuchynSestava";
import { form_cenovaNabidkaObecna } from "./cenovaNabidkaObecna";
import { form_odskrtavaciSeznam } from "./odskrtavaciSeznam";
import { form_interniKalkulace } from "./interniKalkulace";
import { form_dodatekKeSmlouve } from "./dodatekKeSmlouve";
import { form_formularProZamereni } from "./formularProZamereni";
import { form_smlouvaODilo } from "./smlouvaODilo";
import { form_predavaciProtokol } from "./predavaciProtokol";
import { form_pripravenostStavby } from "./pripravenostStavby";

/**
 * Register all forms
 *
 * @param repo Form repository
 */
export function registerForms(repo: FormRepository) {

	repo.register(form_zadavaciProtokol);
	repo.register(form_odskrtavaciSeznam);
	repo.register(form_interniKalkulace);
	repo.register(form_cenovaNabidkaKuchynSestava);
	repo.register(form_cenovaNabidkaObecna);
	repo.register(form_gdpr);
	repo.register(form_smlouvaODilo);
	repo.register(form_dodatekKeSmlouve);
	repo.register(form_predavaciProtokol);
	repo.register(form_formularProZamereni);
	repo.register(form_pripravenostStavby);

}
